// Third-party
import React from 'react';

// Components
import DatesDisclaimer from './DatesDisclaimer';

// Utils
import { getHoldingsAsAtDates } from '@/utils/disclaimers/comparison';
import { formatMessageWithLocale } from '@/utils/i18n';

// Types
import ComparisonItem from '@/types/comparison-item';
import Locale from '@/types/locale';

interface Props {
  items: ComparisonItem[];
  locale?: Locale;
  showItemNames?: boolean;
}

const HoldingsDisclaimer = ({ items, locale, showItemNames }: Props) => (
  <DatesDisclaimer
    globalPrefix={formatMessageWithLocale('Disclaimers.Holdings', locale)}
    itemDates={getHoldingsAsAtDates(items, locale)}
    itemPrefix={formatMessageWithLocale('Disclaimers.AsAt', locale)}
    locale={locale}
    showItemNames={showItemNames}
  />
);

export default HoldingsDisclaimer;
